import { render } from "./PaperChat.vue?vue&type=template&id=40ab071c&scoped=true"
import script from "./PaperChat.vue?vue&type=script&lang=js"
export * from "./PaperChat.vue?vue&type=script&lang=js"

import "./PaperChat.vue?vue&type=style&index=0&id=40ab071c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ab071c"]])

export default __exports__